import React from "react"
import Loader from "semantic-ui-react/dist/es/elements/Loader/Loader"

export default function Loading({ message }) {
  return (
    <div style={{ width: "100%", minHeight: "10em" }}>
      <Loader active>{message || ""}</Loader>
    </div>
  )
}
